import { createSlice } from "@reduxjs/toolkit";

const initialBlockState = {
  listLoading: false,
  actionsLoading: false,
  countBlock: 0,
  blockList: null,
  blockForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const blockSlice = createSlice({
  name: "block",
  initialState: initialBlockState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      }
    },
    blocksFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;

      state.blockList = entities;
      state.countBlock = totalCount;
    },
    blockCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.blockList.push(action.payload.block);
    },
    blockFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.blockForEdit = data || {};
      state.error = null;
    },
  },
});

